import Api from '@/services/Api'

export default {
  login (credentials) {
    return Api().post('adminlogin', credentials)
  }
}

// AuthenticationService.register({
//     email: 'testing@gmail.com',
//     password: '12345'
// })
